import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false,
    prefixFheCenter: ''
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHE__SET_BOXES':
            return core.setBoxes(state, action.boxes);
        case 'FHE__UPDATE_BOX':
            return core.updateBox(state, action.box);
        case 'FHE__UPDATE_BOX_STATUS':
            return core.updateBoxStatus(state, action.macAddress, action.boxIsConnected);
        case 'FHE__SET_PREFIX_FHE_CENTER':
            return core.setPrefixFheCenter(state, action.prefixFheCenter);
        case 'FHE__UPDATE_BOX_IP':
            return core.updateBoxIp(state, action.macAddress, action.ipAddress);
        case 'FHE__UPDATE_BOX_SYS_INFO':
            return core.updateBoxSysInfo(state, action.macAddress, action.boxSysInfo);
        case 'FHE__UPDATE_ZWAVE_STATUS':
            return core.updateZwaveStatus(state, action.macAddress, action.status);
        case 'FHE__UPDATE_BOX_UPGRADE':
            return core.updateBoxUpgrade(state, action.macAddress, action.upgrade);
        case `FHE__SWAP_BOX`:
            return core.swapBox(state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Boxes/reducer.js